/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';

import {
    OVERLAY_SET_GHOST_MODE,
    SET_OVERLAY_HIGHLIGHT_HORIZONTAL_LIMIT,
    SET_OVERLAY_HIGHLIGHT_HORIZONTAL_POSITION,
    SET_OVERLAY_HIGHLIGHT_VERTICAL_LIMIT,
    SET_OVERLAY_HIGHLIGHT_VERTICAL_POSITION,
} from './overlayhighlight.types';

export const setOverlayHighlightVerticalPositionAction = (verticalPosition: number): AnyAction => ({
    type: SET_OVERLAY_HIGHLIGHT_VERTICAL_POSITION,
    payload: {
        verticalPosition,
    },
});

export const setOverlayHighlightHorizontalPositionAction = (
    horizontalPosition: number[],
): AnyAction => ({
    type: SET_OVERLAY_HIGHLIGHT_HORIZONTAL_POSITION,
    payload: {
        horizontalPosition,
    },
});

export const setOverlayHighlightVerticalLimitAction = (verticalLimit: number): AnyAction => ({
    type: SET_OVERLAY_HIGHLIGHT_VERTICAL_LIMIT,
    payload: { verticalLimit },
});

export const setOverlayHighlightHorizontalLimitAction = (horizontalLimit: number[]): AnyAction => ({
    type: SET_OVERLAY_HIGHLIGHT_HORIZONTAL_LIMIT,
    payload: { horizontalLimit },
});

export const overlaySetGhostModeAction = (isOverlayGhostHighlightActive: boolean): AnyAction => ({
    type: OVERLAY_SET_GHOST_MODE,
    payload: { isOverlayGhostHighlightActive },
});
